// 汇率计算
import { getCookie } from '@/apis/cookie';


export const fixRate = (price, exrate, market) => {
  const lang = getCookie('lan') || 'en_US';
  // if (lang === 'el_GR') { lang = 'zh_CN' }
  if (!exrate) {
    return '--';
  }
  const larate = exrate[lang] || exrate.en_US;
  if (!larate) {
    return '--';
  }
  const pric = larate[market] * price;
  if (`${parseFloat(pric)}` !== 'NaN') {
    const rate = typeof larate.symbolPrecision !== 'undefined' ? larate.symbolPrecision : larate.coin_precision;
    return larate.lang_logo + pric.toFixed(rate);
  }
  return '--';
};


// 时间格式化
export const formatTime = (dateTime) => {
  const date = new Date(dateTime);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  function s(t) {
    return t < 10 ? `0${t}` : t;
  }

  return `${year}/${s(month)}/${s(day)} ${s(hours)}:${s(minutes)}:${s(seconds)}`;
};
// 时间格式化 2019-09-09
export const date = Date.prototype.format = function(fmt) {
  var o = {
     "M+" : this.getMonth()+1,                 //月份
     "d+" : this.getDate(),                    //日
     "h+" : this.getHours(),                   //小时
     "m+" : this.getMinutes(),                 //分
     "s+" : this.getSeconds(),                 //秒
     "q+" : Math.floor((this.getMonth()+3)/3), //季度
     "S"  : this.getMilliseconds()             //毫秒
 };
 if(/(y+)/.test(fmt)) {
         fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
 }
  for(var k in o) {
     if(new RegExp("("+ k +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
  }
 return fmt;
}
// 精度计算E+处理方法
export const fixDEAdd = (num, precision) => {
  if (`${num}` === '0') {
    if (!window.parseFloat(precision)) return 0;
    return '0.'.padEnd(precision + 2, '0');
  }
  if (!num) return '--';

  const number = parseFloat(num);
  const strN = num.toString();
  const flag = number < 0;
  let result = strN;

  if (strN.toLowerCase().indexOf('e') > -1) {
    const n = strN.match(/(\d+?)(?:\.(\d*))?e([+-])(\d+)/);
    const nl = n[1]; // 小数点左边
    const nr = n[2]; // 小数点右边
    const type = n[3]; //  + / -
    const floatN = n[4]; // 科学计数法的位数

    let params = '';
    let pr = nr.substr(floatN);

    if (pr) pr = `.${pr}`;
    if (type !== '-') {
      for (let i = 0; i < floatN; i += 1) {
        const p = nr[i] || '0';
        params += p;
      }
      result = nl + params + pr;
    } else {
      let strl = '0';
      for (let i = 0; i < floatN; i += 1) {
        const p = nl[nl.length - i - 1] || '0';
        params = p + params;
      }
      if (nl.length > floatN) strl = nl.substr(0, nl.length - floatN);
      result = `${strl}.${params}${nr}`;
    }
  }

  if (precision) {
    let pal = `${result.split('.')[0]}.`;
    const par = result.split('.')[1] || '';

    for (let i = 0; i < precision; i += 1) {
      pal += par[i] || '0';
    }
    result = pal;
  }


  if (result.length > 14) {
    const arry = result.split('.');
    if (arry[0].length > 14) {
      result = `${arry[0].slice(0, 14)}+`;
    } else {
      result = result.slice(0, 13);
      if (result.indexOf('.') === 12) {
        result = result.slice(0, 12);
      }
    }
  }

  return `${flag ? '-' : ''}${result}`;
};
// 精度计算
export const fixD = (num, precision) => {
  // num初始化
  if (`${num}` === '0') {
    if (!window.parseFloat(precision)) {
      return 0;
    }
    return '0.'.padEnd(precision + 2, '0');
  }
  if (!num) {
    return '--';
  }
  // 暂用 ----
  // if (num.length > 14) {
  //   let rNum = num.slice(0, 14);
  //   if (num[13] === '.') {
  //     rNum = rNum.slice(0, 13);
  //   }
  //   return `${rNum}+`;
  // }
  // ----------
  let flag = false;
  if (parseFloat(num) < 0) {
    flag = true;
  }
  //const newnum = `${Math.abs(parseFloat(num))}`;
  const newnum = `${num}`.charAt(0) == '-' ? `${num}`.substring(1) : `${num}`;
  if (newnum === 'NaN') {
    return '--';
  }
  let fixNum = newnum;
  // 科学计数法计算
  if (newnum.toLowerCase().indexOf('e') > -1) {
    if (newnum.toLowerCase().indexOf('+') > -1) return fixDEAdd(newnum, precision);
    const a = newnum.toLowerCase().split('e');
    let b = a[0];
    const c = Math.abs(parseFloat(a[1]));
    let d = '';
    let h = b.length;
    let i;
    if (a[0].split('.')[1]) {
      b = a[0].split('.')[0] + a[0].split('.')[1];
      h = a[0].split('.')[0].length;
    }
    for (i = 0; i < c - h; i += 1) {
      d += '0';
    }
    fixNum = `0.${d}${b}`;
  }
  // 精度格式化
  // precision初始化
  if (`${precision}` !== '0' && !precision) {
    return (flag ? '-' : '') + fixNum;
  }
  if (`${parseFloat(num)}` === 'NaN') {
    return (flag ? '-' : '') + fixNum;
  }
  const fNum = fixNum.split('.');
  if (precision === 0) {
    fixNum = parseInt(fixNum, 10);
  } else if (precision > 0 && fNum[1]) {
    if (fNum[1].length > precision) {
      if (fNum[1].indexOf('999999999') > -1) {
        const s = parseFloat(fixNum).toFixed(precision + 1);
        fixNum = s.slice(0, s.length - 1);
      } else {
        fixNum = `${fNum[0]}.${fNum[1].slice(0, precision)}`;
      }
    } else {
      fixNum = parseFloat(fixNum).toFixed(precision);
    }
  } else {
    fixNum = parseFloat(fixNum).toFixed(precision);
  }
  /*if (fixNum.length >= 14 && fixNum.indexOf('.') > -1) {
    const arry = fixNum.split('.');
    if (arry[0].length > 14) {
      fixNum = `${arry[0].slice(0, 14)}+`;
    } else {
      fixNum = fixNum.slice(0, 13);
      if (fixNum.indexOf('.') === 12) {
        fixNum = fixNum.slice(0, 12);
      }
    }
  }*/
  return (flag ? '-' : '') + fixNum;
};

// 删除小数点最后面的0
export const lastD = (num) => {
  if (!num) return num;
  const newNum = `${num}`;
  const str = newNum.split('.')[1];
  if (!str) return newNum;

  function substring(stri) {
    const arr = stri.split('');
    for (let i = arr.length - 1; i >= 0; i -= 1) {
      if (!arr[i]) return newNum.split('.')[0];
      if (arr[i] === '0') {
        arr.splice(i);
      } else {
        break;
      }
    }
    if (!arr.length) return newNum.split('.')[0];
    return `${newNum.split('.')[0]}.${arr.join('')}`;
  }

  return substring(str);
};



// 获取url里的参数
export const fixUrl = (name) => {
  const text = window.location.search.substring(1).split('&');
  let v = null;
  for (let i = text.length - 1; i >= 0; i -= 1) {
    const key = text[i].split('=')[0];
    const value = text[i].split('=')[1];
    if (key === name) {
      v = value;
      break;
    }
  }
  return v;
};

// 输入框
export const fixInput = (val, fixs,options) => {
  let fix = fixs;
  if (!fix === 0) {
    fix = fix || 10;
  }
  let v = `${val}`;
  // 操作1
  // 用户行为 直接上来打个.
  // 解决方案 置换成0.
  if (v.charAt(0) === '.') {
    v = '0.';
  }
  // 操作2
  // 用户行为 打多个点.
  // 解决方案 保留第二个点以前的数值
  const strArr = [...v].reduce((res, c) => {
    if (res[c]) {
      res[c] += 1;
    } else {
      res[c] = 1;
    }
    return res;
  }, {});
  if (strArr['.'] === 2) {
    const arr = v.split('.');
    v = `${arr[0]}.${arr[1]}`;
  }
  // 操作3
  // 用户行为 小数点后输入超过该币种精度限制
  // 解决方案 保留该精度之前的数值
  if (v.indexOf('.') !== -1) {
    const integer = v.split('.')[0]; // 整数
    let decimal = v.split('.')[1]; // 小数
    if (decimal.length > fix) {
      decimal = decimal.substring(0, fix);
      v = `${integer}.${decimal}`;
    }
  }
  // 操作4
  // 用户行为 转成汉语拼音后可输入汉字字母等字符
  // 解决方案 干掉写入的文字
  const strKey = Object.keys(strArr);
  strKey.forEach((c) => {
    let str = '01234567890.';
    if (fix === 0) { str = '01234567890'; }
    if (str.indexOf(c) === -1) {
      v = v.split(c)[0] + (v.split(c)[1] || '');
    }
  });
  //首位和第二位连续两个0的情况
  if (options && options.num) {
    if (v.charAt(0) === '0' && v.charAt(1) >= '0') {
      v = v.substring(1)
    }
  }
  //首位不能输入0的情况
  if (options && options.zero) {
    if (v.charAt(0) === '0') {
      v = ''
    }
  }
  return v;
};
// 计算倒计时 仅支持到天位
export const getTime = (spkTime) => {
  let dateSpan = Math.abs(spkTime);
  if (!dateSpan) { return ''; }
  // 计算天
  const iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
  // 计算小时
  dateSpan -= (iDays * (24 * 3600 * 1000));
  let iHour = `${Math.floor(dateSpan / (3600 * 1000))}`;
  iHour = iHour.length === 1 ? `0${iHour}` : iHour;
  // 计算分钟
  dateSpan -= (iHour * (3600 * 1000));
  let iMin = `${Math.floor(dateSpan / (60 * 1000))}`;
  iMin = iMin.length === 1 ? `0${iMin}` : iMin;
  // 计算秒钟
  dateSpan -= (iMin * (60 * 1000));
  let iSec = `${Math.floor(dateSpan / 1000)}`;
  iSec = iSec.length === 1 ? `0${iSec}` : iSec;
  return {
    day: iDays,
    hour: iHour,
    min: iMin,
    sec: iSec,
  };
};
// 计算时间 2012:12:12 12:12:12
export function timeFn(dataObj, data) {
  let fmt = data;
  const o = {
    'M+': dataObj.getMonth() + 1, // 月份
    'd+': dataObj.getDate(), // 日
    'h+': dataObj.getHours(), // 小时
    'm+': dataObj.getMinutes(), // 分
    's+': dataObj.getSeconds(), // 秒
    'q+': Math.floor((dataObj.getMonth() + 3) / 3), // 季度
    S: dataObj.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${dataObj.getFullYear()}`).substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k])
        : ((`00${o[k]}`).substr((`${o[k]}`).length)));
    }
  });
  return fmt;
}
export const getComplexType = (obj) => {
  const type = Object.prototype.toString.call(obj);
  return type.match(/\s(.+)]/ig)[0].trim().replace(']', '');
};


//防抖函数
export function _debounce(fn, delay) {

  var delay = delay || 200;
  var timer;
  return function () {
      var th = this;
      var args = arguments;
      if (timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(function () {
          timer = null;
          fn.apply(th, args);
      }, delay);
  };
}

// 时间格式化精确到日
export const formatTimeDay = (dateTime) => {
  const date = new Date(dateTime);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  function s(t) {
    return t < 10 ? `0${t}` : t;
  }

  return `${year}/${s(month)}/${s(day)}`;
};

// 输入框
export const newFixInput = (val, fixs, options) => {
  let fix = fixs;
  if (!fix === 0) {
    fix = fix || 10;
  }
  let v = `${val}`;
  // 操作1
  // 用户行为 直接上来打个.
  // 解决方案 置换成0.
  if (v.charAt(0) === '.') {
    v = '0.';
  }
  // 操作2
  // 用户行为 打多个点.
  // 解决方案 保留第二个点以前的数值
  const strArr = [...v].reduce((res, c) => {
    if (res[c]) {
      res[c] += 1;
    } else {
      res[c] = 1;
    }
    return res;
  }, {});
  if (strArr['.'] === 2) {
    const arr = v.split('.');
    v = `${arr[0]}.${arr[1]}`;
  }
  // 操作3
  // 用户行为 小数点后输入超过该币种精度限制
  // 解决方案 保留该精度之前的数值
  if (v.indexOf('.') !== -1) {
    const integer = v.split('.')[0]; // 整数
    let decimal = v.split('.')[1]; // 小数
    if (decimal.length > fix) {
      decimal = decimal.substring(0, fix);
      v = `${integer}.${decimal}`;
    }
  }
  // 操作4
  // 用户行为 转成汉语拼音后可输入汉字字母等字符
  // 解决方案 干掉写入的文字
  const strKey = Object.keys(strArr);
  strKey.forEach((c) => {
    let str = '01234567890.-';
    if (fix === 0) {
      str = '01234567890-';
    }
    if (str.indexOf(c) === -1) {
      v = v.split(c)[0] + (v.split(c)[1] || '');
    }
  });

  // 操作5
  // 用户行为 ①输入多个负号- ②输入的负号不在第一位
  // 解决方案 ①保留第二个负号之前的数  ②截取负号之前的数
  const first = find(v, '-', 0)
  const second = find(v, '-', 1)
  if (first !== -1 && second !== -1) {
    v = '-' + v.split('-')[1] + v.split('-')[2]
  }
  if (first !== -1 && v.charAt(0) !== '-') {
    v = v.split('-')[0] + v.split('-')[1]
  }
  // 特殊配置--禁止输入负数
  if (options && options.minus) {
    strKey.forEach((c) => {
      let str = '01234567890.';
      if (fix === 0) {
        str = '01234567890';
      }
      if (str.indexOf(c) === -1) {
        v = v.split(c)[0] + (v.split(c)[1] || '');
      }
    });
  }

  // 特殊配置：--整数位数
  if (options && options.ints) {
    if (v.indexOf('.') !== -1) {
      let integer = v.split('.')[0]; // 整数
      let decimal = v.split('.')[1]; // 小数
      if (decimal.length > fix) {
        decimal = decimal.substring(0, fix);
        v = `${integer}.${decimal}`;
      }
      if (integer.length > options.ints) {
        integer = integer.substring(0, options.ints);
        v = `${integer}.${decimal}`;
      }
    } else {
      let ints = v
      if (ints.length > options.ints) {
        ints = ints.substring(0, options.ints);
        v = `${ints}`;
      }
    }
  }
  //首位和第二位连续两个0的情况
  if (options && options.num) {
    if (v.indexOf('-') === -1) {
      if (v.charAt(0) === '0' && v.charAt(1) >= '0') {
        v = v.substring(0, 1)
      }
    } else {
      if (v.charAt(1) === '0' && v.charAt(2) >= '0') {
        v = v.substring(0, 2)
      }
    }

  }
  //首位不能输入0的情况,配置不能输入负数的情况
  if (options && options.zero) {
    if (v.charAt(0) === '0') {
      v = ''
    }
  }
  return v;
};
// 获取指定字符串出现指定次数的位置
function find(str, cha, num) {
  let x = str.indexOf(cha);
  for (let i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1);
  }
  return x;
}
// len表示保留几位数小数
const floatRound = (num, len = 2) => {
  let n = divide(Math.round(times(num, Math.pow(10, len))), Math.pow(10, len))
  return n.toFixed(len)
}
// 乘法浮点数计算
export const multiply = (num1, num2) => {
  if ((num1 || num1 === 0) && (num2 || num2 === 0)) {
    const num1String = num1.toString()
    const num2String = num2.toString()
    const num1Digits = (num1String.split('.')[1] || '').length
    const num2Digits = (num2String.split('.')[1] || '').length
    const baseNum = Math.pow(10, num1Digits + num2Digits)
    return Number(num1String.replace('.', '')) * Number(num2String.replace('.', '')) / baseNum
  }
}
// 除法浮点数计算
export const divide = (a, b) => {
  var c, d, e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) { }
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) { }
  return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), parseFloat((c / d * Math.pow(10, f - e)).toPrecision(12));
}

// 科学技术法
export const fixToNum = (num) => {
  num = Number(num)
  var m = num.toExponential().match(/\d(?:.(\d*))?e([+-]\d+)/);
  return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
}

// 数字千分位分隔
export const formatNum = (num) => {
  num = num + '';
  var str = "";
  for (var i = num.length - 1, j = 1; i >= 0; i--, j++) {
    if (j % 3 == 0 && i != 0) {//每隔三位加逗号，过滤正好在第一个数字的情况  
      str += num[i] + ",";//加千分位逗号  
      continue;
    }
    str += num[i];
  }
  return str.split('').reverse().join("");
}

// 数字千分位分隔包含小数
export const thousand = (a) => {
  var arr = new Array();
  var xiaoshu = "";  //用来纪录参数小数数值包含小数点
  var zhengshu = "";  //用来纪录参数录整数数值
  if (a < 1000) {    //当参数小于1000的时刻直接返回参数
    return a;
  } else {

    let t = a.toString();   //将整数转换成字符串
    if (t.indexOf('.') > 0) {   //假如参数存在小数，则纪录小数部份与整数部份
      var index = t.indexOf('.');
      xiaoshu = t.slice(index, t.length);
      zhengshu = t.slice(0, index);
    } else {   //不然整数部份的值就即是参数的字符范例
      zhengshu = t;
    }
    var num = parseInt(zhengshu.length / 3);   //推断须要插进去千位支解符的个数

    //将整数1234567890部份拆分为2部份，变量head:1   变量body:123456789
    var head = zhengshu.slice(0, zhengshu.length - num * 3);
    if (head.length > 0) {  //假如head存在，则在head背面加个千位分隔符，
      head += ',';
    }
    var body = zhengshu.slice(zhengshu.length - num * 3, zhengshu.length);

    //将body字符串123456789转换成一个字符数组arr2 = ['123','456','789']
    var arr2 = new Array();
    for (var i = 0; i < num; i++) {
      arr2.push(body.slice(i * 3, i * 3 + 3));
    }
    body = arr2.join(',');   //将数组arr2经由过程join(',')   要领，拼接成一个以逗号为距离的字符串

    zhengshu = head + body;  //拼接整数部份
    var result = zhengshu + xiaoshu;   //末了拼接整数和小数部份
    return result;   //返回效果
  }
}


// 用于计算字符长度
export const calcCharLength = (param) => {
  var totalLength = 0;
  // UTF-8编码
  for (var i = 0; i < param.length; i++) {
    if (param.charCodeAt(i) <= parseInt("0x7F")) {
      totalLength += 1;
    } else if (param.charCodeAt(i) <= parseInt("0x7FF")) {
      totalLength += 2;
    } else if (param.charCodeAt(i) <= parseInt("0x7FFFF")) {
      totalLength += 3;
    } else if (param.charCodeAt(i) <= parseInt("0x1FFFF")) {
      totalLength += 4;
    } else if (param.charCodeAt(i) <= parseInt("0x3FFFFFF")) {
      totalLength += 5;
    } else {
      totalLength += 6;
    }
  }
  return totalLength;
}

// // 用于获取最大长度范围内, 输入字符的极限长度字符串
export const limitByteLength = (originStr, maxLen) => {
  var totalLength = 0;
  var newStr = "";
  // UTF-8编码
  for (var i = 0; i < originStr.length; i++) {
    if (originStr.charCodeAt(i) <= parseInt("0x7F")) {
      totalLength += 1;
    } else if (originStr.charCodeAt(i) <= parseInt("0x7FF")) {
      totalLength += 2;
    } else if (originStr.charCodeAt(i) <= parseInt("0x7FFFF")) {
      totalLength += 3;
    } else if (originStr.charCodeAt(i) <= parseInt("0x1FFFF")) {
      totalLength += 4;
    } else if (originStr.charCodeAt(i) <= parseInt("0x3FFFFFF")) {
      totalLength += 5;
    } else {
      totalLength += 6;
    }

    if (totalLength > maxLen) break;
    newStr += originStr[i];
  }
  return newStr;
}
